const CONSENT_STORAGE_KEY = 'cookieConsent';
const CONSENT_EVENT = 'cookie-consent-changed';

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const safeGetItem = (key) => {
  if (!isBrowser()) return null;
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    console.warn('Unable to access localStorage:', error);
    return null;
  }
};

const safeSetItem = (key, value) => {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    console.warn('Unable to persist to localStorage:', error);
  }
};

export const getConsentStatus = () => safeGetItem(CONSENT_STORAGE_KEY);

export const hasAnalyticsConsent = () => getConsentStatus() === 'accepted';

export const updateConsentStatus = (status) => {
  safeSetItem(CONSENT_STORAGE_KEY, status);

  if (!isBrowser()) return;
  try {
    window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: status }));
  } catch (error) {
    console.warn('Unable to dispatch consent change event:', error);
  }
};

export const subscribeToConsentChanges = (handler) => {
  if (!isBrowser() || typeof handler !== 'function') {
    return () => {};
  }

  const wrappedHandler = (event) => handler(event.detail);
  window.addEventListener(CONSENT_EVENT, wrappedHandler);

  return () => {
    window.removeEventListener(CONSENT_EVENT, wrappedHandler);
  };
};

export const CONSENT_EVENT_NAME = CONSENT_EVENT;
